import * as React from "react";
import type { SVGProps } from "react";
const SvgRadio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.947 7.052a1 1 0 1 0-1.414 1.415zM18 12.005h-1zm-2.467 3.537a1 1 0 1 0 1.414 1.415zm-8.48 1.406a1 1 0 0 0 1.414-1.415zM6 11.995h1zm2.467-3.538a1 1 0 1 0-1.414-1.415zm11.31-4.234a1 1 0 1 0-1.414 1.414zm-1.414 14.14a1 1 0 1 0 1.414 1.414zm-14.14 1.414a1 1 0 1 0 1.414-1.414zM2.003 12h1zm3.634-6.363a1 1 0 1 0-1.414-1.414zM13 12a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1a1 1 0 0 1-1-1H9a3 3 0 0 0 3 3zm-1-1a1 1 0 0 1 1-1V9a3 3 0 0 0-3 3zm1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm3.533-2.533a5 5 0 0 1 1.086 1.623l1.847-.766a7 7 0 0 0-1.52-2.272zm1.086 1.623a5 5 0 0 1 .38 1.915h2a7 7 0 0 0-.533-2.68zm.38 1.915a5 5 0 0 1-.38 1.915l1.847.766A7 7 0 0 0 19 12.005zm-.38 1.915a5 5 0 0 1-1.086 1.623l1.414 1.415a7 7 0 0 0 1.52-2.272zm-8.152 1.613A5 5 0 0 1 7.38 13.91l-1.847.766a7 7 0 0 0 1.52 2.272zM7.38 13.91a5 5 0 0 1-.38-1.915H5a7 7 0 0 0 .533 2.68zm-.38-1.915a5 5 0 0 1 .38-1.915l-1.847-.766A7 7 0 0 0 5 11.995zm.38-1.915a5 5 0 0 1 1.086-1.623L7.053 7.042a7 7 0 0 0-1.52 2.272zm10.982-4.443A9 9 0 0 1 20.998 12h2a11 11 0 0 0-3.22-7.777zM20.998 12a9 9 0 0 1-2.635 6.363l1.414 1.414A11 11 0 0 0 22.997 12zm-15.36 6.363A9 9 0 0 1 3.001 12h-2a11 11 0 0 0 3.22 7.777zM3.001 12a9 9 0 0 1 2.635-6.363L4.223 4.223A11 11 0 0 0 1.003 12z"
    />
  </svg>
);
export default SvgRadio;
